import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background-image: url('/img/background.png');
  background-size: cover;
`;
